import { SvgIcon, SvgIconProps } from '@mui/material';

export default function ArrowRightIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path d="m0 21 7-7-7-7z" fill={props.color ?? 'black'} />
    </SvgIcon>
  );
}
